<template>
	<div class="flag">
		<el-dialog
		  :title="$t('other.a390')"
		  :visible.sync="isFlageCopy"
		  @close="$emit('update:isFlage',false)"
		  width="50%"
		  >
		<div>
			<div>
				<el-radio-group style="width: 100%;" v-model="radio2">
					<div style="display: flex;align-items: center;" >
						<div class="flagbox" v-for="item in fageStyleList">
						  <el-radio  :label=item.colorId  @change="ttop(item)">
							  <span v-show="item.colorId !== 0" :style="item.style"> </span>
							 <span v-show="item.colorId == 0" >{{$t('other.a391')}}	</span>
						  </el-radio>
						  
						</div>
					</div>
					
				  </el-radio-group>
				  <div v-show="noFlage !== null">
					  <el-input
					    type="textarea"
					    autosize
						:autosize="{ minRows: 2, maxRows: 4}"
					    :placeholder="$t('other.a319')"
					    v-model="textarea3">
					  </el-input>
				  </div>
			</div>
		</div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="isFlageCopy = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="setFlags()">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>

		
	</div>
</template>

<script>

	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	import config from '../pages/allOrders/config.js'
	import api2 from '../api/moudles/print.js'
	export default {
		name: "Flag",
		data() {
			return {
				fageStyleList:config.flagList,
				textarea2:'',
				radio2:0,
				list:[],
				list2:[],
				isFlageCopy:this.isFlage,
				textarea3:'',
				chooseParams:{
					colorId: null,
					desc: this.$t('other.a354'),
					flagId: null,
				},
				noFlage:null,
				color1:''
			
			};
		},

		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				userFlags: state => state.print.userFlags,
			}),
			
		
			
			// flagList(){
			// 	let arr=[{
			// 		id:0,
			// 		checked:false,
			// 		flagId:null,
			// 		style:{
			// 		'display': 'inline-block',
			// 		'background-color': '#05eb28',
			// 		'width': '20px',
			// 		'height': '20px',
			// 		'border-radius': '5px'
			// 	    }
			// 	}]
			// 	this.userFlags.forEach(p => {
			// 		this.fageStyleList.forEach(k => {
			// 			if(p.color === k.id){
			// 				k.flagId=p.flagId
			// 				k.desc=p.describe
			// 				arr.push(k)
			// 			}
			// 		})
			// 	})
				
			// 	this.UPDATA_PAGE(arr)
			// 	return arr
			// }

		},
		props: {
			isFlage: {
				type: Boolean,
				default: false
			},
			

		},
		watch: {
			isFlage(){
				this.isFlageCopy=this.isFlage
			}
			

		},
		created() {
			
		},
		methods: {
			
			...mapActions('print', [
				'setOrderFlag',
				'addUserFlags',
				'getUserFlags'
			
			]),

			
			...mapMutations('print', [
				'UPDATA_PAGE',
			]),
			
			addColor(){
				alert(888)
			},
			choose(){
				alert(88887777)
			},
			
			//选择旗帜时触发
			   ttop(item){
				   
				console.log(item)
				if(item.colorId == 0) {
					this.noFlage=null
					this.chooseParams={
					 flagId:null,
					 colorId:null,
					 desc:this.textarea3
					}
				}else{
					this.noFlage=item.colorId
					this.fageStyleList.forEach(p => {
					 if(p.colorId === item.colorId){
					  this.textarea3=p.desc
					 }
					})
					
					this.chooseParams={
					 flagId:item.flagId,
					 colorId:item.colorId,
					 desc:this.textarea3
					}
				}
			    
				
			    console.log(this.chooseParams)
			    // console.log(this.fageStyleList)
			    
			   },
			
			
			addFlags(){
				this.addUserFlags(this.list2)
			},
			//选定旗帜后，点击确定
		   setFlags(){
			this.chooseParams.desc=this.textarea3
			this.$emit('setFlags',this.chooseParams)
		
			this.isFlageCopy=false
		   },
			

		}
	}
</script>

<style>
	
</style>
